export const annualReportVotingLink = 'http://www.WebVoteDirect.com/NWM_MTG/';
export const nmFoundationBaseUrl = 'http://www.northwesternmutual-foundation.com';